import { MY_FATOORAH_ENVIRONMENT } from "./Constants";

export const BASE_URL = "https://api.ellytbeeh.qa";
// export const BASE_URL = "http://localhost:3500";

export const SOCKET_URL = "https://api.ellytbeeh.qa:8585";
// export const SOCKET_URL = "http://localhost:8585";

export const API_ENDPOINTS = {
  LOGIN: "/auth/login",
  SIGNUP: "/auth/signup",
  LOGIN_AS_GUEST: "/auth/login_as_guest_player",
  LOGIN_BY_UID: "/auth/login_by_uid",
  FORGOT_PASSWORD: "/auth/forgot_password",
  RESET_PASSWORD: "/auth/reset_password",
  TWILIO: "/twilio",
  SEND_VERIFICATION_CODE: "/send_verification_code",
  CHECK_VERIFICATION_CODE: "/check_verification_code",
  CATEGORIES: "/categories",
  UNLOCK: "/unlock",
  CATEGORY_UNLOCK_CODES: "/category_unlock_codes",
  STATS: "/stats",
  RATINGS: "/ratings",
  CORRECT_ANSWERS_PERCENTAGE: "/correct_answers_percentage",
  QUESTIONS: "/questions",
  GET_NUMBER_OF_REMAINING_QUESTIONS: "/get_number_of_remaining_questions",
  GET_RANDOM_QUESTION: "/get_random_question",
  GIVE_RATING: "/give_rating",
  GIVE_ANSWER: "/give_answer",
  ANSWERS: "/answers",
  GAMES: "/games",
  QUESTION_ID: "/question_id",
  PLAYERS: "/players",
  REFERRAL_UNLOCKED_CODES: "/referral_unlocked_codes",
  UNFINISHED_GAMES: "/unfinished_games",
  QUESTIONS_HISTORY: "/questions_history",
  SEARCH: "/search",
  PACKAGES: "/packages",
  DISCOUNT_CODES: "/discount_codes",
  DISCOUNT_CODE_CHECK_IF_REDEEMABLE: "/check_if_redeemable",
  DISCOUNT_CODE_REDEEM: "/{:id}/redeem",
  TRANSACTIONS: "/transactions",
  FILTER: "/filter_by",
  UPLOAD_FILE: "/upload_file",
  PAYMENT: "/payment",
  QRCODE: "/qrcode",
  GENERATE: "/generate",
  INITIATE_PAYMENT: `/initiate?mode=${MY_FATOORAH_ENVIRONMENT}`,
  EXECUTE_PAYMENT: `/execute?mode=${MY_FATOORAH_ENVIRONMENT}`,
  STATUS_PAYMENT: `/status?mode=${MY_FATOORAH_ENVIRONMENT}`,
};
